import { Card } from "primereact/card";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Login } from "../../components/Login/Login";
import "./LoginPage.css";

export function LoginPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="loginPage">
      <Card
        title={t("Home.Login.Title")}
        className="card"
        style={{ maxWidth: "300px", margin: "auto" }}
      >
        <Login
          registerVisible={true}
          forgotPasswordVisible={true}
          afterLogin={() => {
            navigate("/home");
          }}
        />
      </Card>
    </div>
  );
}
